import { useEffect, useState } from "react";
import RedCross from "../../assets/images/cross-red.svg";
import constants from "./constants.json";
import "./style.css";
import { addDataLayer } from "../../utils/utility";
import { Dialog } from "../../components";
import { getCartId, getOrderId } from "../../services/cartService";

interface PaymentFailureType {
  error: any;
  setError: (val: any) => void;
  loading: boolean;
  tryPaymentAgain: () => void;
}

const PaymentFailure = (props: PaymentFailureType) => {
  const [show, setShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  useEffect(() => {
    addDataLayer({ cart_id: getCartId(), order_id: getOrderId() }, "purchase_failed");
    if (props.error) {
      setShow(true);
      setErrorMsg(props.error.message);
    }
  }, [props.error]);

  const closeModal = () => {
    setShow(false);
    setErrorMsg("");
    props.setError(null);
  };

  function getSubHeading(errorMsg: string) {
    return !errorMsg || errorMsg === 'error in payment'
      ? constants.subheading
      : errorMsg;
  }
  
  const subHeading = getSubHeading(errorMsg);
  const message = constants.message;

  return (
    <Dialog
      title={
        <div className="flex">
          <img
            className="failure-check-container mr-2"
            src={RedCross}
            alt="Failure"
          />
          {constants.heading}
        </div>
      }
      submit={props.tryPaymentAgain}
      submitTitle="Try Again"
      loading={props.loading}
      showFooter={true}
      open={show}
      handleClose={closeModal}
    >
      <div className="payment-failure-content">
        <p className="font-bold my-2">{subHeading}</p>
        <p
          className="text-grey-scale-slate my-2"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
    </Dialog>
  );
};

export default PaymentFailure;
